import { render, staticRenderFns } from "./bindMobile.vue?vue&type=template&id=06fd62e1&scoped=true&"
import script from "./bindMobile.vue?vue&type=script&lang=js&"
export * from "./bindMobile.vue?vue&type=script&lang=js&"
import style0 from "./bindMobile.vue?vue&type=style&index=0&id=06fd62e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd62e1",
  null
  
)

export default component.exports